if (!customElements.get("sticky-header")) {
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.stickyHeader =
                this.closest(".shopify-section") || this.parentElement;
            this.header = this.querySelector("header");
            this.menu = this.querySelector(".header__inline-menu");
            this.headerIcons = this.querySelector(".header__icons");
            this.predictiveSearch = this.querySelector("predictive-search");

            this.isPersistentBambuHeader = Boolean(
                this.querySelector(".header.bambu-header-layout")
            );

            if (this.isPersistentBambuHeader) {
                this.stickyHeader.classList.add("section-header-sticky");
                this.stickyHeader.classList.remove("sticky-animation");
                this.stickyHeader.style.top = "0";
                this.topBar = document.querySelector(".shopify-section.header-top");
                this.currentScrollTop = window.scrollY;
                this.topBarVisible = window.scrollY < (this.topBar?.offsetHeight || 0);
                this.onPersistentScroll = () => {
                    const y = Math.max(0, window.scrollY);
                    if (Math.abs(y - this.currentScrollTop) < 4 && y > 0) return;
                    this.topBarVisible = y < this.currentScrollTop || y === 0;
                    this.currentScrollTop = y;
                    this.updateTopBar();
                };
                this.onPersistentResize = () => this.updateTopBar();
                if (this.topBar) {
                    this.topBar.style.position = "sticky";
                    this.updateTopBar();
                    this.topBar.classList.add("bambu-sticky-stack");
                    this.stickyHeader.classList.add("bambu-sticky-stack");
                    window.addEventListener("scroll", this.onPersistentScroll, { passive: true });
                    window.addEventListener("resize", this.onPersistentResize);
                }
                return;
            }

            this.headerBounds = {};
            this.currentScrollTop = 0;

            this.onScrollHandler = {
                scroll: this.onScroll.bind(this),
                resize: this.onResize.bind(this),
            };

            window.addEventListener(
                "scroll",
                this.onScrollHandler.scroll,
                false
            );
            window.addEventListener(
                "resize",
                this.onScrollHandler.resize,
                false
            );

            this.createObserver();
        }

        disconnectedCallback() {
            if (this.isPersistentBambuHeader) {
                window.removeEventListener("scroll", this.onPersistentScroll);
                window.removeEventListener("resize", this.onPersistentResize);
                if (this.topBar) {
                    this.topBar.classList.remove("bambu-sticky-stack");
                    this.stickyHeader.classList.remove("bambu-sticky-stack");
                    this.topBar.style.removeProperty("position");
                    this.topBar.style.removeProperty("top");
                }
                return;
            }
            window.removeEventListener("scroll", this.onScrollHandler.scroll);
            window.removeEventListener("resize", this.onScrollHandler.resize);
        }

        updateTopBar() {
            if (!this.topBar) return;
            const height = this.topBar.offsetHeight;
            this.topBar.style.top = this.topBarVisible ? "0px" : `-${height}px`;
            const visibleHeight = this.topBarVisible ? height : Math.max(0, height - window.scrollY);
            const top = `${visibleHeight}px`;
            if (this.stickyHeader.style.top !== top) {
                this.stickyHeader.style.top = top;
                // Move the product tabs in the same frame as both header layers.
                document.dispatchEvent(new Event("bambu:sticky-offset-change"));
            }
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.stickyHeader);
        }

        onResize() {
            return window.innerWidth;
        }

        onScroll() {
            requestAnimationFrame(this.reveal.bind(this));

            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            const scrollTrigger = 500;

            const updateHeaderHeightOnDesktop = this.header.classList.contains(
                "header--in-single-row"
            )
                ? this.stickyHeader?.offsetHeight
                : this.stickyHeader?.offsetHeight -
                  this.menu?.offsetHeight -
                  13; // minus padding-top
            const updateHeaderHeightOnMobile =
                this.stickyHeader?.offsetHeight -
                this.headerIcons?.offsetHeight -
                24; // minus 1.5rem padding top

            if (this.onResize() > 980 && this.menuHeight < 60)
                updateHeaderHeightOnDesktop = updateHeaderHeightOnMobile;

            if (scrollTop < this.currentScrollTop) {
                this.stickyHeader.style.top = "0";
            } else {
                // prevent header scroll animation if search uses.
                if (this.predictiveSearch?.hasAttribute("open")) return;

                if (this.onResize() > 980)
                    this.stickyHeader.style.top =
                        updateHeaderHeightOnDesktop > 0
                            ? "-" + updateHeaderHeightOnDesktop + "px"
                            : "0";
                else
                    this.stickyHeader.style.top =
                        updateHeaderHeightOnMobile > 0
                            ? "-" + updateHeaderHeightOnMobile + "px"
                            : "0";
            }

            this.currentScrollTop = scrollTop;
        }

        reveal() {
            if (this.stickyHeader.style.top == "0px") {
                if (
                    document.documentElement.scrollTop >
                    this.stickyHeader.offsetHeight * 2
                )
                    this.applySticky();
                else this.reset();
            } else this.applySticky();
        }

        applySticky() {
            this.stickyHeader.classList.add("section-header-sticky");
            this.stickyHeader.classList.remove("sticky-animation");
        }

        reset() {
            this.stickyHeader.classList.add("sticky-animation");
            this.stickyHeader.classList.remove("section-header-sticky");
            this.closeMenuDisclosure();
            this.closeSearchModal();
        }

        closeMenuDisclosure() {
            this.disclosures =
                this.disclosures ||
                this.stickyHeader.querySelectorAll("details-disclosure");
            this.disclosures.forEach((disclosure) => disclosure.close());
        }

        closeSearchModal() {
            this.searchModal =
                this.searchModal ||
                this.stickyHeader.querySelector("details-modal");
            this.searchModal && this.searchModal.close(false);
        }
    }

    customElements.define("sticky-header", StickyHeader);
}
